/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Container } from '@material-ui/core';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import LazyImage from '../../../GraphqlCommonComponents/TrendingProducts/Partials/LazyImage';
import { actions as tagManagerActions } from '../../../../../../state/ducks/TagManager/ducks/TagManager';

const ShopByCardInterior = ({ category }) => {
    const dispatch = useDispatch();
    return (
        <>
            {category?.menu_groups?.menu_item.map((filter) => {
                const srcSet = filter?.image?.url;

                return (
                    <Container container className="overflow-hidden zero-padding">

                        <Link
                            to={{
                                pathname: '/c/all-plants',
                                search: filter?.link?.href,
                            }}
                            style={{ textDecoration: 'none' }}
                            onClick={() => dispatch(tagManagerActions.trackEvent({
                                eventName: 'feature_interaction',
                                eventCategory: 'Homepage',
                                eventAction: 'Click',
                                eventLabel: `${category?.menu_groups?.title} - ${filter?.link?.title}`,
                            }))}
                        > {/*eslint-disable-line*/}

                            <div className="shop-by-option">

                                <LazyImage srcSet={srcSet} alt="" imgClass="content icon" width="auto" height="57px" />

                                <div className="content" role="region" aria-label={filter?.link?.title}>{filter?.link?.title}</div>

                            </div>

                        </Link>

                    </Container>
                );
            })}
        </>
    );
};

ShopByCardInterior.propTypes = {
    category: PropTypes.object.isRequired,
};

export default ShopByCardInterior;
